import { render, staticRenderFns } from "./PhysicianListSection.vue?vue&type=template&id=09837750&scoped=true"
import script from "./PhysicianListSection.vue?vue&type=script&lang=js"
export * from "./PhysicianListSection.vue?vue&type=script&lang=js"
import style0 from "./PhysicianListSection.vue?vue&type=style&index=0&id=09837750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09837750",
  null
  
)

export default component.exports